import type { AsyncThunk } from '@reduxjs/toolkit'

export interface DataRefreshObject {
	roles: string[]
	thunks: Array<AsyncThunk<any, undefined, any>>
}

const dataRefreshFunctions = new Map<string, DataRefreshObject[]>([])

export { dataRefreshFunctions }
